/**
 * @fileoverview AR-805 — Google Classroom logo, used as the visual anchor of
 * every Classroom surface (prototype: public/images/google_classroom.svg).
 */

import GoogleClassroomLogoSrc from 'assets/arcmosaico/google-classroom.svg'

interface GoogleClassroomLogoProps {
  readonly size?: number
}

export function GoogleClassroomLogo({ size = 20 }: GoogleClassroomLogoProps) {
  return <img src={GoogleClassroomLogoSrc} alt='' width={size} height={size} />
}
